@if (currentItem(); as item) {
  <div
    class="card"
    data-cy="job-opportunity-card"
    tabindex="0"
    role="group"
    [attr.aria-label]="'l-trampo' | translate"
  >
    <po-widget>
      <div class="main po-p-sm-0 po-pb-1 po-xl-p-1 po-mb-2">
        <div class="header">
          <img
            class="po-ml-sm-1 po-ml-0 po-mb-1 logo-image"
            [alt]="item.companyIconDescription"
            [src]="getIconUrl()"
          />
          <p
            class="po-ml-sm-1 po-ml-0 po-mb-1"
            [p-tooltip]="item.divulgationName"
            [p-tooltip-position]="'top'"
          >
            <a
              class="company-link"
              [attr.href]="careerPageUrl()"
              target="_blank"
              data-cy="divulgation-name"
              >{{ item.divulgationName }}</a
            >
          </p>
        </div>

        <div class="po-pl-sm-1 po-pl-0 po-pr-1">
          <div class="title" data-cy="job-opportunity-card-title">
            <a
              class="job-title-link"
              data-gtm="job-opportunity-details"
              data-cy="job-opportunity-card-apply-for-job-title-link"
              [attr.data-link]="item.pageUrl!"
              target="_blank"
              (click)="$event.stopPropagation()"
              [attr.href]="navigateToCareerPage()"
              [attr.title]="item.title"
            >
              <h3 atsTruncateText [p-tooltip]="item.title" [p-tooltip-position]="'top'">
                {{ item.title }}
              </h3>
            </a>
          </div>

          <div class="opening-type-tags po-mt-1 po-mb-1" data-cy="job-opportunity-card-tags">
            @if (item.isHybrid) {
              <po-tag
                class="po-mr-1"
                [p-value]="'l-hybrid' | translate"
                p-color="#dcd1fb"
                p-text-color="#1a017e"
              >
              </po-tag>
            }
            @if (item.isHomeOffice) {
              <po-tag
                class="po-mr-1"
                [p-value]="'l-remote' | translate"
                p-color="#e796f6"
                p-text-color="#1a017e"
              >
              </po-tag>
            }
            @if (item.isLocal) {
              <po-tag
                class="po-mr-1"
                [p-value]="'l-presential' | translate"
                p-color="#7ae373"
                p-text-color="#1a017e"
              >
              </po-tag>
            }
          </div>

          <section class="content po-mt-2">
            <p data-cy="job-opportunity-card-localization" class="po-mt-1 d-f-items-center">
              <i class="an an-map-pin mr-4"></i>
              @if (item.cityName && item.stateSmallName) {
                {{ item.cityName }} / {{ item.stateSmallName }}
              } @else {
                {{ 'l-uninformed' | translate }}
              }
            </p>

            <p
              class="po-mt-1"
              data-cy="job-opportunity-card-salary"
              class="po-mt-1 d-f-items-center"
            >
              <i class="an an-currency-circle-dollar mr-4"></i>
              {{
                ({ minimum: item.salaryRangeMinimum, maximum: item.salaryRangeMaximum }
                  | salaryRange
                  | async)! | translate
              }}
            </p>

            <p data-cy="job-opportunity-card-hiring-regime" class="po-mt-1 d-f-items-center">
              <i class="an an-briefcase mr-4"></i>
              <span [innerHtml]="item.hiringRegime | hiringRegime: '' : 3 | async"></span>
            </p>
          </section>
        </div>
      </div>

      <div class="datetime-publication">
        <p
          [innerHtml]="
            'l-published-at'
              | translate
                : {
                    date: item.dateTimePublication | timeSince | async,
                  }
          "
        ></p>
        <p class="date">{{ item.dateTimePublication | date: 'shortDate' }}</p>
      </div>

      <div class="actions-footer">
        @if (item.jobApplicationType !== jobApplicationTypeEnum.Simplified) {
          <a
            class="po-button po-button-secondary po-sm-12 po-mt-2 po-mb-1"
            data-cy="job-opportunity-card-quickly-apply-button"
            [attr.data-link]="createUrlJobOpportunityApplication()"
            p-kind="secondary"
            target="_blank"
            (click)="$event.stopPropagation()"
            [attr.href]="navigateToApplicancy()"
            [attr.title]="'l-apply' | translate"
          >
            {{ 'l-apply' | translate }}
          </a>
        } @else {
          <div class="simplified-application-buttons po-mt-2 po-mb-1">
            <po-button
              class="easy-apply-button po-p-0"
              data-cy="job-opportunity-card-quickly-apply-button"
              (click)="openEasyApply($event)"
              (keydown.enter)="openEasyApply($event)"
              (keydown.space)="openEasyApply($event)"
              p-kind="secondary"
              [p-label]="'l-easy-apply' | translate"
            >
            </po-button>

            @if (showWhatsAppApplication()) {
              <a
                class="po-button po-button-secondary whatsapp-application-button"
                p-kind="secondary"
                [attr.href]="item.whatsAppLink"
                target="_blank"
                rel="noopener noreferrer"
                [attr.title]="'l-whatsapp-apply' | translate"
                [attr.aria-label]="'l-whatsapp-apply' | translate"
                data-cy="whatsapp-easy-apply"
                (click)="$event.stopPropagation()"
              >
                <span class="ats-icon-whatsapp" aria-hidden="true"></span>
              </a>
            }
          </div>
        }

        <a
          class="po-button po-button-primary po-sm-12"
          data-gtm="job-opportunity-details"
          data-cy="job-opportunity-card-apply-for-job-button"
          [attr.data-link]="item.pageUrl!"
          p-kind="primary"
          target="_blank"
          (click)="$event.stopPropagation()"
          [attr.href]="navigateToCareerPage()"
          [attr.title]="'l-apply-for-job' | translate"
        >
          {{ 'l-apply-for-job' | translate }}
        </a>
      </div>
    </po-widget>

    @if (item.jobApplicationType === jobApplicationTypeEnum.Simplified && enableModal()) {
      <po-modal
        [p-title]="'l-easy-apply' | translate"
        #poModal
        [p-hide-close]="true"
        aria-modal="true"
        role="dialog"
        class="easy-apply-modal"
      >
        @if (initModalEasyApply() && !easyApplySuccessful()) {
          <ats-easy-apply-forms
            [jobOpportunityId]="item.id!"
            [tenantId]="item.tenantId!"
            [applicationSource]="defaultApplicationSource"
            [showFooter]="false"
            [enableNavigation]="false"
            (formStatusChanges)="easyApplyFormStatusChanges($event)"
          ></ats-easy-apply-forms>
        }

        @if (easyApplySuccessful()) {
          <ats-easy-apply-success [showFooter]="false"></ats-easy-apply-success>
        }

        <po-modal-footer [p-disabled-align]="false">
          @if (initModalEasyApply() && !easyApplySuccessful() && !easyApplyFormLoading()) {
            <po-button
              class="po-sm-12 po-mb-sm-1 po-md-5 po-lg-5 po-xl-5"
              [p-label]="'l-cancel' | translate"
              (p-click)="closeEasyApply(); poModal.close()"
            ></po-button>
            <po-button
              class="po-sm-12 po-md-7 po-lg-7 po-xl-7"
              p-kind="primary"
              [p-label]="'l-send-job-application' | translate"
              (p-click)="onSubmitEasyApply()"
              [p-disabled]="disableSendApplication()"
              [p-loading]="sendingApplication()"
            ></po-button>
          }

          @if (easyApplySuccessful()) {
            <po-button
              p-kind="primary"
              class="po-sm-12"
              [p-label]="'l-close' | translate"
              (p-click)="closeEasyApply(); poModal.close()"
            ></po-button>
          }
        </po-modal-footer>
      </po-modal>
    }
  </div>
}
